<script setup>
import {useChatStore} from "@/stores/chat.js";
import {Icon} from "@iconify/vue";

const chatStore = useChatStore();
const props = defineProps({
  message: {
    type: Object
  },
});

function extractTextWithLinks(text) {
  const urlRegex = /(https?:\/\/[^\s]+)/g; // Match all links
  const parts = text.split(urlRegex); // Split text by links

  return parts.map((part) => ({
    type: urlRegex.test(part) ? "link" : "text",
    value: part,
  }));
}
</script>

<template>
  <div v-if="message.offerLink">
    <div
        class="flex flex-col gap-3 divide-y divide-slate-500 rounded-2xl bg-blue-500/30 text-slate-300 p-3">
      <p>{{ message.offerType }} Offer - {{ message.offerGame }}</p>
      <div class="pt-3 flex flex-col gap-3">
        <p>{{ message.offerTitle }}</p>
        <div>
          <p v-if="message.offerID" class="text-sm text-slate-400">#{{ message.offerID }}</p>
          <p class="text-sm text-slate-400">{{ message.offerType }} - {{ message.offerGame }}</p>
        </div>
        <div class="w-max">
          <a v-if="message.offerLink" :href="message.offerLink" target="_blank"
             class="btn btn-outline-light text-sm font-normal py-2 rounded-lg flex flex-row gap-2 items-center justify-center">
            <Icon icon="heroicons:link"/>
            <span>Open Offer</span>
          </a>
        </div>
      </div>
    </div>
  </div>
  <div v-else
       class="flex flex-col gap-3 divide-y divide-slate-500 rounded-2xl bg-blue-500/30 text-slate-300 p-3">
    <p>{{ message.offerType }} Offer - {{ message.offerGame }}</p>
    <div class="pt-3 flex flex-col gap-3">
      <p>{{ message.offerTitle }}</p>
      <div>
        <p v-if="message.offerID" class="text-sm text-slate-400">#{{ message.offerID }}</p>
        <p class="text-sm text-slate-400">{{ message.offerType }} - {{ message.offerGame }}</p>
      </div>
      <div
          class="text-contrent dark:text-slate-300 text-sm font-normal rounded-2xl flex-1 whitespace-pre-wrap break-all">
        <p style="word-break: break-word">
          <template v-for="(part, partIndex) in extractTextWithLinks(message.message)" :key="partIndex">
            <template v-if="part.type === 'text'">{{ part.value }}</template>
            <a v-else :href="part.value" target="_blank" class="underline"
               :class="chatStore.chatData.contact === message.from ? 'text-success-600' : 'text-blue-400'">
              {{ part.value }}
            </a>
          </template>
        </p>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">

</style>